import ManageActiveSubstanceFamilyTable from './ManageActiveSubstanceFamilyTable'

const ManageActiveSubstanceFamily = {
  Table: ManageActiveSubstanceFamilyTable,
}

export default ManageActiveSubstanceFamily
